import { Lia_02, Lia_12 } from "../../Chart.js";
import { NewEntry } from "../../entry/NewEntry.js";
import { Template } from "../../template/Template.js";
import { findVariableValue } from "../../template/findVariableValue.js";

export const VAT_DEBT: Template = {
  id: "dea486b0-d058-4135-b4a1-c43f98ee7946",
  name: "Puudujääva käibemaksu kandmine maksuvõlaks",
  description:
    "Kuu viimasel kuupäeval jooksva kuu käibemaksu (Lia-02) kandmine maksuvõlaks (Lia-12)." +
    " Õige summa muudab jooksva kuu käibemaksu saldo 0-ks.",
  variables: [
    {
      name: "Title",
      type: "text"
    },
    {
      name: "Date",
      type: "date"
    },
    {
      name: "Amount",
      type: "amount_eur"
    }
  ],
  initialValues: [
    {
      name: "Title",
      value: "Puudujääva käibemaksu arvestus"
    }
  ],
  generate: (values) => {
    const date = findVariableValue("Date", values);
    const amount = Math.round(parseFloat(findVariableValue("Amount", values)) * 100);

    const entry: NewEntry = {
      title: findVariableValue("Title", values),
      items: [
        {
          title: "Puudujääva käibemaksu arvestus maksuvõlaks",
          date: date,
          amount: amount,
          eurAmount: amount,
          currency: "eur",
          debit: Lia_02,
          credit: Lia_12
        }
      ]
    };

    return { type: "success", entry };
  }
};
